import { ESupplyInfoDialogMutations, ISupplyInfoDialogActionTypes, } from '@/vuex-store/supply-info-dialog/types';
const actions = {
    [ISupplyInfoDialogActionTypes.setIsSupplyInfoDialogOpen]({ commit }, isOpen = true) {
        commit(ESupplyInfoDialogMutations.SET_IS_SUPPLY_INFO_DIALOG_OPEN, isOpen);
    },
    [ISupplyInfoDialogActionTypes.setSuppliersInfo]({ commit }, info) {
        commit(ESupplyInfoDialogMutations.SET_SUPPLIERS_INFO, info);
    },
    [ISupplyInfoDialogActionTypes.resetSuppliersInfo]({ commit }) {
        commit(ESupplyInfoDialogMutations.RESET_SUPPLIERS_INFO);
    },
};
export default actions;
